import { render, staticRenderFns } from "./SenserSetting.vue?vue&type=template&id=45c28b5d&"
import script from "./SenserSetting.vue?vue&type=script&lang=js&"
export * from "./SenserSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports